import plural from 'helpers/plural';

angular.module('gym.components').directive('waiverMembershipSummary', ["MembershipPlanService", function(MembershipPlanService) {
  return {
    restrict: 'E',
    scope: {
      waiver: '=',
      currency: '=',
      internal: '='
    },
    template: require('templates/components/waivers/waiver_membership_summary.html.slim'),
    controller: ["$scope", "$filter", function($scope, $filter) {
      var isRecurring, isUpfront, upfrontPaymentDate;
      $scope.familyMembershipStrategy = $scope.waiver.signed_waiver_form_attributes.family_membership_strategy;
      $scope.membershipPlan = function(id) {
        return $scope.waiver.signed_waiver_form_attributes.membership_plan_options.find(function(m) {
          return m.id === id;
        });
      };
      $scope.isNotAttending = function(contact) {
        return !contact.attending && $scope.familyMembershipStrategy === 'every_attendee_pays_membership';
      };
      $scope.membershipLabel = function(contact) {
        var match;
        match = $scope.membershipPlan(contact.membership_plan_id);
        return (match != null ? match.label : void 0) || 'None selected';
      };
      $scope.activeContacts = function() {
        return $scope.waiver.signed_waiver_contacts_attributes.filter(function(c) {
          return !c._destroy;
        });
      };
      $scope.noCharge = function(contact) {
        return $scope.familyMembershipStrategy === 'only_parent_pays_membership' && contact.position !== 1;
      };
      $scope.hasPayment = function(contact) {
        var plan;
        plan = $scope.membershipPlan(contact.membership_plan_id);
        return plan.cost_upfront > 0 || plan.cost_repeat > 0;
      };
      $scope.selectDate = function(contact, event) {
        event.preventDefault();
        event.stopPropagation();
        $scope.maxChangeDate = $scope.getMaxChangeDate(contact);
        return contact.rescheduling = true;
      };
      $scope.contactName = function(c) {
        if (c.first_name && c.last_name) {
          return `${c.first_name} ${c.last_name}`;
        } else {
          if (c.position === 1) {
            return 'Parent / Guardian';
          } else {
            return `Dependant / Child #${c.position - 1}`;
          }
        }
      };
      $scope.minChangeDate = moment().toDate();
      $scope.getMaxChangeDate = function(contact) {
        var plan;
        plan = $scope.membershipPlan(contact.membership_plan_id);
        if ($scope.internal || !plan.waiver_start_date_limit_number) {
          return moment().add(365, 'days').toDate();
        } else {
          return moment().add(plan.waiver_start_date_limit_number, plan.waiver_start_date_limit_unit).toDate();
        }
      };
      $scope.membershipStartDate = function(contact) {
        var plan, startDate;
        if (contact.requested_membership_start_date) {
          return $filter('date')(contact.requested_membership_start_date);
        }
        plan = $scope.membershipPlan(contact.membership_plan_id);
        startDate = MembershipPlanService.getStartDate(plan);
        if (startDate) {
          return $filter('date')(startDate);
        } else {
          return 'immediately';
        }
      };
      $scope.specifiedStartDate = function(contact) {
        var plan;
        plan = $scope.membershipPlan(contact.membership_plan_id);
        return plan.specified_start_date;
      };
      $scope.membershipExpires = function(contact) {
        var period, plan;
        plan = $scope.membershipPlan(contact.membership_plan_id);
        if (plan.term_unit && plan.term_number > 0) {
          period = plural(plan.term_unit, plan.term_number, true);
          return `after ${period}`;
        } else {
          return 'does not expire';
        }
      };
      $scope.startDateChangeAvailable = function(contact) {
        var plan;
        plan = $scope.membershipPlan(contact.membership_plan_id);
        return plan.allow_customer_to_choose_start_date_on_waiver;
      };
      $scope.isStartDatePassed = function(id) {
        var plan;
        plan = $scope.membershipPlan(id);
        return plan.specified_start_date && moment(plan.specified_start_date).isBefore(moment(), 'day');
      };
      $scope.selectedStartDate = function(contact) {
        var plan;
        plan = $scope.membershipPlan(contact.membership_plan_id);
        return contact.requested_membership_start_date || (plan != null ? plan.specified_start_date : void 0);
      };
      isUpfront = function(plan) {
        return plan.cost_upfront > 0;
      };
      isRecurring = function(plan) {
        return plan.cost_repeat > 0 && plan.charge_interval_unit;
      };
      $scope.recurringPaymentsOnSecondRow = function(contact) {
        var plan, startDate;
        plan = $scope.membershipPlan(contact.membership_plan_id);
        startDate = $scope.selectedStartDate(contact);
        return isRecurring(plan) && isUpfront(plan) && startDate;
      };
      $scope.paymentsLabel = function(contact) {
        var plan;
        plan = $scope.membershipPlan(contact.membership_plan_id);
        if (!isRecurring(plan) && isUpfront(plan)) {
          return 'Payment';
        }
        if ($scope.recurringPaymentsOnSecondRow(contact)) {
          return 'Initial payment';
        }
        return 'Payments';
      };
      $scope.fullWidth = function() {
        return _.find($scope.activeContacts(), function(contact) {
          var plan, startDate;
          plan = $scope.membershipPlan(contact.membership_plan_id);
          startDate = $scope.selectedStartDate(contact);
          return startDate && isRecurring(plan);
        });
      };
      $scope.paymentsSecondRow = function(contact) {
        var date, intervalUnit, paymentDate, plan, repeatPayment, startDate;
        plan = $scope.membershipPlan(contact.membership_plan_id);
        repeatPayment = $filter('currency')(plan.cost_repeat, $scope.currency);
        intervalUnit = plural(plan.charge_interval_unit, plan.charge_interval_number, plan.charge_interval_number > 1);
        startDate = $scope.selectedStartDate(contact);
        paymentDate = (function() {
          switch (plan.default_repeat_date_strategy) {
            case 'start_repeat_payments_one_period_after_upfront':
              return moment(startDate).add(plan.charge_interval_number, plan.charge_interval_unit);
            case 'start_repeat_payments_on_membership_start_date':
              return startDate;
            case 'start_repeat_payments_relative_to_start_or_upfront':
              return moment(startDate).add(plan.relative_repeat_date_number, plan.relative_repeat_date_unit);
          }
        })();
        date = moment(paymentDate).format('D MMMM YYYY');
        return `${repeatPayment} every ${intervalUnit}, starting ${date} until membership expires`;
      };
      upfrontPaymentDate = function(contact) {
        var paymentDate, plan, startDate;
        plan = $scope.membershipPlan(contact.membership_plan_id);
        startDate = $scope.selectedStartDate(contact);
        return paymentDate = (function() {
          switch (plan.default_upfront_date_strategy) {
            case 'charge_upfront_amount_on_start_date':
              return moment(startDate);
            case 'charge_upfront_amount_asap':
              return moment();
            case 'charge_upfront_amount_relative_to_start_date':
              if (plan.relative_upfront_date_direction === 'before') {
                return moment(startDate).subtract(plan.relative_upfront_date_number, plan.relative_upfront_date_unit);
              } else {
                return moment(startDate).add(plan.relative_upfront_date_number, plan.relative_upfront_date_unit);
              }
          }
        })();
      };
      return $scope.paymentsFirstRow = function(contact) {
        var date, plan, recurringInterval, repeatPayment, startDate, upfrontPayment, upfrontPaymentDue;
        plan = $scope.membershipPlan(contact.membership_plan_id);
        startDate = $scope.selectedStartDate(contact);
        upfrontPayment = $filter('currency')(plan.cost_upfront, $scope.currency);
        upfrontPaymentDue = startDate ? (date = moment(upfrontPaymentDate(contact)).format('D MMMM YYYY'), `, due ${date}`) : '';
        repeatPayment = $filter('currency')(plan.cost_repeat, $scope.currency);
        recurringInterval = plural(plan.charge_interval_unit, plan.charge_interval_number, plan.charge_interval_number > 1);
        if (isRecurring(plan)) {
          if (isUpfront(plan)) {
            if ($scope.recurringPaymentsOnSecondRow(contact)) {
              return `${upfrontPayment}${upfrontPaymentDue}`;
            } else {
              return `Initial payment ${upfrontPayment} and then ${repeatPayment} every ${recurringInterval}`;
            }
          } else {
            if (startDate) {
              return $scope.paymentsSecondRow(contact);
            } else {
              return `${repeatPayment} paid every ${recurringInterval}`;
            }
          }
        } else {
          if (isUpfront(plan)) {
            if ($scope.recurringPaymentsOnSecondRow(contact)) {
              return `${upfrontPayment}${upfrontPaymentDue}`;
            } else {
              return `one-off payment of ${upfrontPayment}${upfrontPaymentDue}`;
            }
          } else {
            return "none";
          }
        }
      };
    }]
  };
}]);
